import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-referenzen',
  standalone: true,
  imports: [],
  templateUrl: './referenzen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './referenzen.component.scss'
})
export class ReferenzenComponent {

}
